import { useSelector } from 'react-redux';

import { TProductCategory } from '@lib/core/products/types';
import {
  selectAssociatedRetailerLocation,
  selectIsRetailerLocationLoading,
  selectIsRetailerLocationStoreTypeEcommerce,
  selectRetailerCatalogType,
  selectRetailerDesignSet,
  selectRetailerLocationAddOns,
  selectRetailerLocationAddress,
  selectRetailerLocationCoordinates,
  selectRetailerLocationCustomStyle,
  selectRetailerLocationDescription,
  selectRetailerLocationEmail,
  selectRetailerLocationId,
  selectRetailerLocationImages,
  selectRetailerLocationLogo,
  selectRetailerLocationName,
  selectRetailerLocationPhone,
  selectRetailerLocationProducerId,
  selectRetailerLocationProductCategories,
  selectRetailerLocationSlug,
  selectRetailerLocationStoreType,
  selectRetailerLocationTasteMatch,
  selectRetailerLocationWebsite,
  selectRetailerPhysicalAddress,
  selectRetailerWebAddress,
} from '@lib/core/retailers/selectors/retailerLocation';
import { TAssociatedKioskRetailerLocation, TRetailerLocationStoreType } from '@lib/core/retailers/types';
import { TDesignSetName } from '@lib/core/retailers/types/designSets';
import { ITheme } from '@lib/tools/shared/helpers/interfaces';

type IRetailerLocationDetails = {
  isRetailerLocationStoreTypeEcommerce: boolean;
  addOns: string[];
  retailerDesign: TDesignSetName;
  retailerLocationId: string;
  retailerLocationSlug: string;
  retailerStoreType: TRetailerLocationStoreType;
  retailerLocationProductCategories: TProductCategory[];
  retailerLocationCustomStyle: ITheme;
  isRetailerLocationLoading: boolean;
  associatedRetailerLocation: TAssociatedKioskRetailerLocation;
  retailerLocationName: string;
  retailerLocationWebsite: string;
  retailerLocationLogo: string;
  retailerLocationPhone: string;
  retailerLocationEmail: string;
  retailerLocationDescription: string;
  retailerLocationImages: string[];
  retailerLocationAddress: string;
  retailerLocationCoordinates: number[] | null;
  retailerLocationProducerId: string;
  retailerLocationTasteMatch: Record<string, number>;
  retailerLocationCatalogType: string;
  retailerPhysicalAddress: string;
  retailerWebAddress: string;
};

export const useRetailerLocation = (): IRetailerLocationDetails => {
  return {
    addOns: useSelector(selectRetailerLocationAddOns),
    associatedRetailerLocation: useSelector(selectAssociatedRetailerLocation),
    isRetailerLocationLoading: useSelector(selectIsRetailerLocationLoading),
    isRetailerLocationStoreTypeEcommerce: useSelector(selectIsRetailerLocationStoreTypeEcommerce),
    retailerDesign: useSelector(selectRetailerDesignSet),
    retailerLocationAddress: useSelector(selectRetailerLocationAddress),
    retailerLocationCatalogType: useSelector(selectRetailerCatalogType),
    retailerLocationCoordinates: useSelector(selectRetailerLocationCoordinates),
    retailerLocationCustomStyle: useSelector(selectRetailerLocationCustomStyle),
    retailerLocationDescription: useSelector(selectRetailerLocationDescription),
    retailerLocationEmail: useSelector(selectRetailerLocationEmail),
    retailerLocationId: useSelector(selectRetailerLocationId),
    retailerLocationImages: useSelector(selectRetailerLocationImages),
    retailerLocationLogo: useSelector(selectRetailerLocationLogo),
    retailerLocationName: useSelector(selectRetailerLocationName),
    retailerLocationPhone: useSelector(selectRetailerLocationPhone),
    retailerLocationProducerId: useSelector(selectRetailerLocationProducerId),
    retailerLocationProductCategories: useSelector(selectRetailerLocationProductCategories),
    retailerLocationSlug: useSelector(selectRetailerLocationSlug),
    retailerLocationTasteMatch: useSelector(selectRetailerLocationTasteMatch),
    retailerLocationWebsite: useSelector(selectRetailerLocationWebsite),
    retailerPhysicalAddress: useSelector(selectRetailerPhysicalAddress),
    retailerStoreType: useSelector(selectRetailerLocationStoreType),
    retailerWebAddress: useSelector(selectRetailerWebAddress),
  };
};
